import { css } from "@emotion/react";
import cn from "classnames";
import type { HTMLInputAutoCompleteAttribute } from "react";
import { swarovskiDropdownStyles } from "./layouts/shop-layouts/checkout-page-layout/CheckoutComponent/checkout-steps/02-shipping/subcomponents/CheckoutAddressFormEditor";
import { disabledFormStyles } from "./layouts/shop-layouts/checkout-page-layout/CheckoutComponent/shared/form/DisabledFormStyles";
import { errorMessageStyles } from "./layouts/shop-layouts/checkout-page-layout/CheckoutComponent/shared/form/errorMessageStyles";
import { SwarovskiDropdown2 } from "./layouts/shop-layouts/checkout-page-layout/CheckoutComponent/shared/SwarovskiDropdown";
import { fontColor, FONTS, fontSize } from "./styles/fonts";

type Dropdown3Props<State> = {
  placeholder: string | undefined;
  disabled?: boolean;
  required: boolean | "yes-but-without-native-validation";
  autoComplete: HTMLInputAutoCompleteAttribute | undefined;
  value: (state: State) => string | undefined;
  values: Array<{ value: string; label: string }>;
  onChange: (v: string) => void;
  emptyValue: {
    value: string;
    label: string;
  };
  fieldName: string;
  state: State;
  errorMessage?: string;
  emptyLabel?: string;
};

export function SwarovskiDropdown3<State>({
  placeholder,
  disabled,
  required,
  autoComplete,
  fieldName,
  state,
  errorMessage,
  emptyLabel,
  emptyValue,
  values,
  onChange,
  value,
}: Dropdown3Props<State>) {
  const selected = values.find(i => i.value === value(state)) || emptyValue;

  return (
    <div className={cn(!!disabled ? "disabled" : undefined, { "has-error": !!errorMessage })} css={dropdownStyles}>
      {typeof placeholder !== "undefined" && (
        <span
          css={[
            fontSize.x2,
            css`
              position: absolute;
              left: 12px;

              top: -0.4em;

              background: var(--bg-placeholder);

              .disabled & {
                background: var(--bg-disabled);
              }

              transform: scale(0.75);
              transform-origin: top left;
            `,
          ]}
        >
          {placeholder}
        </span>
      )}

      <SwarovskiDropdown2
        disabled={!!disabled}
        required={!!required}
        attachStyles={swarovskiDropdownStyles}
        selected={selected}
        emptyLabel={`${emptyLabel}*`}
        name={fieldName}
        onChange={onChange}
        options={values}
        autoComplete={autoComplete}
      />

      {typeof errorMessage === "string" && <span css={errorMessageStyles}>{errorMessage}</span>}
    </div>
  );
}

const dropdownStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x25,
  css`
    height: 40px;
    position: relative;

    border: 1px solid var(--so-green);
    border-radius: 8px;
    padding: 0 12px;

    &:focus-within {
      outline: 1px solid var(--so-green);
    }

    &.has-error {
      background: var(--bg-error);
      color: var(--text-error);
    }

    &.disabled {
      ${disabledFormStyles};
      background: var(--bg-disabled);
    }
  `,
];
